import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgAscenseur = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="ascenseur_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>{`.prestation_cls_fill{fill:${color}`}</style>
		</defs>
		<path
			className="prestation_cls_fill"
			d="M101.19 145.58v222.3h116.14V171.8h-9.98v186.09h-96.17V155.56h202.84v202.33h-80.45v9.99h90.44v-222.3H101.19zM307.25 60.65h-83.67l41.83 55.78 41.83-55.78Zm-19.97 9.99-21.86 29.15-21.86-29.15h43.72ZM117.43 113.1h83.67l-41.83-55.78-41.83 55.78Zm19.97-9.99 21.86-29.15 21.86 29.15H137.4Z"
		/>
	</svg>
)
export default SvgAscenseur